import { render, staticRenderFns } from "./GeograficFormTabs.vue?vue&type=template&id=1a74fbf2"
import script from "./GeograficFormTabs.vue?vue&type=script&lang=ts"
export * from "./GeograficFormTabs.vue?vue&type=script&lang=ts"
import style0 from "./GeograficFormTabs.vue?vue&type=style&index=0&id=1a74fbf2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports